// extracted by mini-css-extract-plugin
export default {"viewBtn":"PrintLink_viewBtn__FCeEM","spin":"PrintLink_spin__2hYCU"};